/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Slow_TooltipInputs */

const es_tools_legajox_slow_tooltip = /** @type {(inputs: Tools_Legajox_Slow_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta herramienta puede demorar más de lo habitual debido a la técnica de scraping que utiliza.`)
};

const en_tools_legajox_slow_tooltip = /** @type {(inputs: Tools_Legajox_Slow_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tool may take longer than usual due to the scraping technique it uses.`)
};

/**
* | output |
* | --- |
* | "This tool may take longer than usual due to the scraping technique it uses." |
*
* @param {Tools_Legajox_Slow_TooltipInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_slow_tooltip = /** @type {((inputs?: Tools_Legajox_Slow_TooltipInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Slow_TooltipInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_slow_tooltip(inputs)
	return en_tools_legajox_slow_tooltip(inputs)
});
export { tools_legajox_slow_tooltip as "tools.legajox.slow_tooltip" }